import type { AnyObject } from '@/common/types';
import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

import type { IHttpParams } from '../types';
import { formatString } from '@/components/organisms/Form/DynamicForm/utils/format-string';
import { formatHeaders } from './format-headers';

export type TReuqestParams = Omit<IHttpParams, 'resultPath'>;

export const request = async (
  request: TReuqestParams,
  metadata: AnyObject = {},
  data?: any,
  params?: AnyObject,
) => {
  const { url: _url, headers = {}, method, timeout = 5000 } = request;

  const formattedUrl = formatString(_url, { ...metadata, ...params });

  const formattedHeaders = formatHeaders(headers, metadata);

  try {
    const config: AxiosRequestConfig = {
      url: formattedUrl,
      method,
      headers: formattedHeaders,
      data,
      timeout,
      withCredentials: true,
      params: request.params,
    };

    const response = await axios(config);

    return response.data;
  } catch (error) {
    console.error('Failed to perform request.', error);

    throw error;
  }
};
